import { styled } from '@mui/material';

export const PolicyStreamPageContainer = styled('div')(({ theme }) => {
  return {
    [theme.breakpoints.up('md')]: {
      maxWidth: '760px',
    },
    [theme.breakpoints.down('md')]: {
      width: '100%',
    },
    // minWidth: '600px',
  };
});
